<mat-accordion
    role="list"
    [attr.aria-label]="'BuySellReviewers' | translate: {Default: 'Buy/Sell Reviewers'}"
>
    <p
        *ngIf="!buySellPlanApprovals?.length"
        class="no-data"
        role="status">
        {{ 'NoReviewers' | translate: {Default: 'No reviewers assigned.'} }}
    </p>

    <mat-expansion-panel
        *ngFor="let approval of buySellPlanApprovals; let i = index"
        [matBadge]="approval.orderNumber"
        matBadgeSize="large"
        matBadgePosition="before"
        [matBadgeDescription]="('ReviewerOrder' | translate: {Default: 'Reviewer order'}) + ': ' + approval.orderNumber"
        [expanded]="approval.comments !== null && approval.comments !== ''"
        role="listitem"
        [attr.aria-label]="
            approval.reviewer?.firstName + ' ' + approval.reviewer?.lastName
            + ', ' + ('Status' | translate: {Default: 'Status'}) + ': '
            + (approval.status?.text || '')
            + (approval.isApproved !== null
                ? ', ' + (approval.isApproved
                    ? ('Approved' | translate: {Default: 'Approved'})
                    : ('Denied' | translate: {Default: 'Denied'}))
                : '')
        "
    >
        <mat-expansion-panel-header>
            <mat-panel-title [attr.aria-label]="
            ('ReviewerOrder' | translate: {Default: 'Reviewer order'}) + ': ' + approval.orderNumber
            + ', ' + ('ReviewerName' | translate: {Default: 'Reviewer name'}) + ': ' + approval.reviewer?.firstName + ' ' + approval.reviewer?.lastName
            + ', ' + ('Status' | translate: {Default: 'Status'}) + ': '
            + (approval.status?.text || '')
            + (approval.isApproved !== null
                ? ', ' + (approval.isApproved
                    ? ('Approved' | translate: {Default: 'Approved'})
                    : ('Denied' | translate: {Default: 'Denied'}))
                : '')
        ">
                <app-employee-label [employee]="approval.reviewer"></app-employee-label>
            </mat-panel-title>

            <mat-panel-description aria-hidden="true">
                <mat-chip-set
                    *ngIf="approval.status?.id !== 'COMPLETE'"
                    [attr.aria-label]="'ReviewerStatus' | translate: {Default: 'Reviewer status'}">
                    <mat-chip
                        [ngClass]="getStatusChipClass(approval?.status?.id)"
                        [attr.aria-label]="approval.status?.text"
                        role="status">
                        {{ approval.status?.text }}
                    </mat-chip>
                </mat-chip-set>

                <mat-chip-set
                    *ngIf="approval.isApproved !== null"
                    [attr.aria-label]="'ApprovalDecision' | translate: {Default: 'Approval decision'}">
                    <mat-chip
                        [ngClass]="approval.isApproved ? 'green-chip' : 'red-chip'"
                        [attr.aria-label]="approval.isApproved
                            ? ('Approved' | translate: {Default: 'Approved'})
                            : ('Denied' | translate: {Default: 'Denied'})"
                        role="status">
                        {{ approval.isApproved
                            ? ('Approved' | translate: {Default: 'Approved'})
                            : ('Denied' | translate: {Default: 'Denied'}) }}
                    </mat-chip>
                </mat-chip-set>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <dl class="approval-comments">
            <dt class="label">
                <strong>{{ 'Comments' | translate: {Default: 'Comments'} }}</strong>
            </dt>
            <dd>
                <p tabindex="0">{{ approval.comments !== null && approval.comments !== ''
                    ? approval.comments
                    : ('NoCommentsAvailable' | translate: {Default: 'No comments available'}) }}</p>
            </dd>
        </dl>
    </mat-expansion-panel>
</mat-accordion>